import download from 'downloadjs'

export default function downloadFile (data, filename, mime) {
  if (data == null) return
  if (data instanceof Blob) return download(data, filename, mime || data.type)
  const isText = typeof mime === 'string' && /^text\//.test(mime)
  const blobType = isText && !/charset=/i.test(mime) ? mime + ';charset=utf-8' : (mime || 'application/octet-stream')
  const blob = new Blob([data], {type: blobType})
  return download(blob, filename, blobType)
}



// WEBPACK FOOTER //
// ./src/utils/downloadFile.js